import * as R from 'ramda'

import schemaAt from 'coact/utils/schema/schemaAt'
import mergeDeep from 'coact/utils/mergeDeep'

import schemaModule from '../../utils/schema/index.js'

import { reqData } from '../purchaseReq/index.js'
import $arrivalProcessData from '../arrivalProcess/dataAccess/index.js'

const schema = R.pipe(
  reqSchema => schemaAt(['items', 0], reqSchema),
  mergeDeep({
    contents: {
      unarrivedQty: $arrivalProcessData.schema.unarrivedQty,
      onTheWayQty: $arrivalProcessData.schema.onTheWayQty,
      stockInItemRefs: {
        type: 'Array',
        contents: [$arrivalProcessData.schema.stockInItemRef],
      },
    },
  }),
  schemaModule.create,
)(reqData.schema)

const index = {
  unarrivedQty: {
    key: { unarrivedQty: 1 },
  },
}

export default {
  schema,
  index,
}
